import React from 'react';
import { Grid, Typography, styled } from '@quillbot/design-system';

import { makeStyles } from '@mui/styles';
import createStyles from '@mui/styles/createStyles';

import { useDispatch, useSelector } from 'react-redux';
import { DEVICE_VIEWPORTS } from 'config/constants';
import { RootState } from '@Common/models/redux/store';
import QuillEditor, { QuillEditorIDS } from '@Common/handlers/quillEditor';
import DeleteInputText from '@Common/components/DeleteInputText';
import wordCounterTrack from '../handlers/track';

const StyledDesktopTitleBar = styled(Grid)`
  && {
    max-height: 63px;
    @media ${DEVICE_VIEWPORTS.xs} {
      display: none;
    }
  }
`;

const StyledGrammarTitle = styled(Grid)`
  && {
    @media ${DEVICE_VIEWPORTS.md}, ${DEVICE_VIEWPORTS.sm} {
      display: none;
    }
  }
`;

function TopControlBar({ inputText }: { inputText: string }) {
  const dispatch = useDispatch();
  const quillDrawer = useSelector((state: RootState) => state.common.quillDrawer);
  const { isDesktop, isIE, isExtension } = useSelector((state: RootState) => state.common.platform);

  return (
    <>
      <StyledDesktopTitleBar
        container
        justifyContent="space-between"
        style={{ padding: '13px 16px' }}
      >
        <Grid style={{ marginBottom: '24px' }} />
        <StyledGrammarTitle item xs={2} sm style={{ alignSelf: 'center' }}>
          <Typography style={{ fontWeight: 'bold' }} component="h2">
            Word Counter
          </Typography>
        </StyledGrammarTitle>
        <Grid item xs style={{ marginTop: '-4px' }}>
          <Grid container>
            <Grid item id="toolbar-location" />
          </Grid>
        </Grid>
        <Grid item xs>
          <Grid container justifyContent="flex-end">
            {inputText && (
              <Grid item>
                <DeleteInputText
                  isQuilling={false}
                  style={{ padding: '0px' }}
                  clearInputText={() => {
                    QuillEditor.getInstance(QuillEditorIDS.WORD_COUNTER_EDITOR)?.setContent('');
                    wordCounterTrack.clickedDeleteButton();
                  }}
                />
              </Grid>
            )}
          </Grid>
        </Grid>
      </StyledDesktopTitleBar>
    </>
  );
}

export default TopControlBar;
